import styled from 'styled-components';

export const OnboardingStepsWrapper = styled.div`
    margin-top: 16px;
    margin-bottom: 8px;
    border-radius: 0px;
`;
